// extracted by mini-css-extract-plugin
module.exports = {"container":"e_VA","title":"e_WA","label":"e_XA"};